import React from 'react';
import {Msg} from './style';

function Error({children}) {
  return <Msg>{children}</Msg>;
}

export default Error;
